// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"19":"66fd303c","680":"7c6933f1","897":"bd7caab3"}[chunkId] + ".css";
};